import { string, shape, arrayOf, bool, objectOf, elementType, func, node, oneOfType } from 'prop-types';

const MAIN_TYPE = 'main';

/**
 * DECORATION_TYPES - The decoration types.
 * @constant
 * @type {Object}
 */
const DECORATION_TYPES = {
  MAPPER: 'mapper',
  COMPONENT: 'component',
  HOC: 'hoc',
  HELPER: 'helper',
  PLUGIN: 'plugin',
  DEFINITION: 'definition',
};

/**
 * POSITION - The positions of component.
 * @constant
 * @type {Object}
 */
const POSITION = {
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
};

/**
 * OWNERSHIPS - The ownerships for plugins.
 * @constant
 * @type {Object}
 */
const OWNERSHIPS = {
  VPP: 'vpp',
  APPAREL: 'apparel',
  REFURBISHED: 'refurbished',
  MSHOPS: 'mshops',
  REVIEWS: 'reviews',
  COMPATS: 'compats',
};

/**
 * The proptypes for the ComponentRenderer.
 * @type {Object}
 * @property {Array[]} list - The list of components to render.
 * @property {Object} componentsToRender - The components to render.
 * @property {Object} componentWrapperType - The component wrapper type.
 * @property {string} className - The class name to render.
 * @property {string} dataTestId - The data test id to render.
 * @property {Function} handleError - The error handler function.
 * @property {Object} metrics - The metrics object.
 * @property {Object} children - The children object.
 * @property {Object} wrapperConfig - The wrapper config object.
 * @property {Object} childrenConfig - The children config object.
 */

const PROPTYPES = {
  list: arrayOf(
    shape({
      id: string,
      type: string,
      props: shape({}),
      show: bool,
    }),
  ).isRequired,
  componentsToRender: objectOf(elementType),
  componentWrapperType: string,
  className: string,
  dataTestId: string,
  handleError: func,
  metrics: shape({}),
  children: oneOfType([node, string]),
  wrapperConfig: shape({
    tag: string,
    className: string,
    dataTestId: string,
    type: string,
  }),
  childrenConfig: shape({
    type: string,
    props: shape({}),
    text: string,
  }),
};

Object.freeze(DECORATION_TYPES);
Object.freeze(POSITION);
Object.freeze(OWNERSHIPS);

export { MAIN_TYPE, DECORATION_TYPES, POSITION, OWNERSHIPS, PROPTYPES };
